import {Injectable} from '@angular/core';
import {PropertyModel, PropertyUsages} from './models/property.model';
import {plainToInstance} from 'class-transformer';
import {map} from 'rxjs/operators';
import {LeModalService, MesApiService, PropertiesQuery} from 'common-shared';
import {PropertyLineModel} from './models/property-line.model';
import {Observable} from "rxjs";
import {PropertyUsagesModalComponent} from "../common/properties/property-usages-modal/property-usages-modal.component";

@Injectable({
  providedIn: 'root'
})
export class PropertyService extends MesApiService {

  constructor(public query: PropertiesQuery, private modalService: LeModalService) {
    super('property');
  }

  getAll$ = this.query.selectAll();

  loadOne(id: string): Observable<PropertyModel> {
    return this.getSingle<PropertyModel>({
      id: id
    }).pipe(map(value => {
      return plainToInstance(PropertyModel, value.data);
    }));
  }

  addNew(property: PropertyModel) {
    return this.add<PropertyModel>(property, {
      action: 'Post'
    }).pipe(map(value => {
      return plainToInstance(PropertyModel, value.data);
    }));
  }

  save(property: PropertyModel) {
    return this.update<PropertyModel>(property.Id, property).pipe(map(value => {
      return plainToInstance(PropertyModel, value.data);
    }));
  }

  remove(property: PropertyModel) {
    return this.delete<PropertyModel>(property.Id).pipe(map(value => {
      return plainToInstance(PropertyModel, value.data);
    }));
  }

  getLocalizedOrDefaultValues(lines: PropertyLineModel[], languageId: string): PropertyLineModel[] {
    const byLanguageLines = lines.filter(line => {
      return line.LanguageId === languageId;
    });
    const defaultLanguageLines = lines.filter(line => {
      return line.LanguageId === null;
    });
    const mergedLines = byLanguageLines.concat(defaultLanguageLines);

    let set = new Set<string>();
    return mergedLines.filter(line => {
      if (!set.has(line.PropertyId)) {
        set.add(line.PropertyId);
        return true;
      }
      return false;
    }, set);
  }

  showPropertyUsages(propertyUsages: PropertyUsages, property: PropertyModel) {
    return this.modalService.show(PropertyUsagesModalComponent, {
      initialState: {
        usages: propertyUsages,
        property: property
      }
    });
  }
}
